<template>
    <div>
        <div class="wrapper">
            <div class="animated fadeIn">
                <b-row>
                    <b-col cols="12" class="mb-3">
                        <b-button variant="primary" @click="$router.push('/admin/questionnaires/toevoegen')" class="pull-right">Campagne toevoegen</b-button>
                    </b-col>
                </b-row>
                <resource-index header="Campagnes" endpoint="questionnaires" show-route="questionnaires.view"/>
            </div>
        </div>
    </div>
</template>

<script>
    import ResourceIndex from '../../components/ResourceIndex';

    export default {
        name: 'questionnaires',
        components: {ResourceIndex},
        computed: {
            userRole () {
                return this.$store.state.userRole
            }
        },
    }
</script>
